<template>
  <div
    class="specific_boost_parent_container"
    :class="[isOpen && 'opened_coupon_container']"
  >
    <div class="specific_booster_container">
      <div class="d-flex-row space-between" @click="toggleOpen">
        <div class="d-flex-row justify-start flex-5" v-if="!selectedClass">
          <p class="t-white font-family-2 bold-l t-white white-space-no">
            {{ $t("class_specialization") }}
          </p>
        </div>

        <div class="d-flex-row justify-start flex-5" v-else-if="selectedClass">
          <img
            :src="selectedClass.image"
            alt="hero_image"
            class="hero_image b-radius-35"
            sizes="30"
            width="30"
          />
          <p class="t-white regular-m white-space-no font-family-2">
            <span class="bold-m">{{ selectedClass.title }}</span> -
            {{ selectedClass.hero_class }}
          </p>
        </div>

        <div class="d-flex-row justify-end flex-5">
          <button @click.stop="clearClass" type="button" v-if="selectedClass">
            <CrossIcon />
          </button>
          <ChevDown />
        </div>
      </div>
    </div>

    <div
      class="booster_list_container hide_scroll cursor-pointer justify-start align-start d-flex-column gap-10"
      v-if="isOpen"
    >
      <div class="d-flex-row justify-start flex-1">
        <input-field
          :variant="'transparent'"
          :size="'small'"
          :icon-start="'SearchOutlinedIcon'"
          placeholder="Search Class"
          v-model="search"
        />
      </div>

      <div
        class="flex-1 d-flex-column justify-start align-start gap-5"
        v-for="(value, key) in gameHeroes"
        :key="booster"
      >
        <div class="d-flex-row height-max-content category_title">
          <div class="divider" />
          <p class="font-family-1 t-light regular-s white-space-no">
            {{ key }}
          </p>
          <div class="divider" />
        </div>

        <div
          class="d-flex-column justify-start align-start gap-1"
          v-for="hero in value"
          role="button"
          :key="hero"
          @click="
            () => {
              closeOutside();
              selectChampion(hero.id);
            }
          "
        >
          <div
            class="d-flex-row space-between height-max-content cursor-pointer class_item b-radius-3"
          >
            <div class="d-flex-row flex-5 justify-start">
              <img
                :src="hero.image"
                alt="hero_image"
                class="hero_image b-radius-35"
                sizes="30"
                width="30"
              />
              <p class="t-white regular-m font-family-2">{{ hero.title }}</p>
            </div>
            <RadioButton :checked="isSelected(hero.id)" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr class="horizontal" style="margin: 8px 0" />

  <!-- {{ gameHeroes }} -->
</template>

<script setup>
import RadioButton from "~/components/custom/RadioButton.vue";
import ChevDown from "~/components/icons/ChevDown.vue";
import InputField from "~/components/custom/InputField.vue";
import CrossIcon from "~/components/icons/CrossIcon.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();
const { currentGameSlug } = useGameComposable();
const search = ref("");
const isOpen = ref(false);

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};
const closeOutside = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const filteredClasses = computed(() => {
  // return boosters.value.filter((item) =>
  //   item.username.toLowerCase().includes(search.value.toLowerCase())
  // );
});

const selectedClass = computed(() => {
  const gameHeroes = gameStore.getGameHeroes;
  if (!gameHeroes) return null;

  if (gameHeroes) {
    const classHero = gameHeroes.find((hero) =>
      checkoutStore.getSelectedHeros.includes(hero.id)
    );

    if (classHero) {
      return classHero;
    }
  }

  return null;
});

const gameHeroes = computed(() => {
  if (!gameStore.getGameHeroes) {
    return {};
  }
  let filteredHeroes = gameStore.getGameHeroes;
  if (search.value) {
    filteredHeroes = filteredHeroes.filter((hero) => {
      return (
        hero.title?.toLowerCase().includes(search.value.toLowerCase()) ||
        hero.hero_class?.toLowerCase().includes(search.value.toLowerCase())
      );
    });
  }
  const groupedByHeroClass = filteredHeroes.reduce((acc, item) => {
    if (!acc[item.hero_class]) {
      acc[item.hero_class] = [];
    }
    acc[item.hero_class].push(item);
    return acc;
  }, {});

  return groupedByHeroClass;
});

const isSelected = (champion) => {
  return checkoutStore.getSelectedHeros.includes(champion);
};

const selectChampion = (championId) => {
  checkoutStore.setOneHeroOther({
    championId,
  });
};
const clearClass = () => {
  checkoutStore.clearHeroes();
};

watch(isOpen, () => {
  gameStore.apiGetMmoGameHeroes({
    gameSlug: currentGameSlug,
  });
});
</script>

<style lang="scss">
.class_specialization_picker {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  gap: 10px;
  width: 100%;
  transition: all 0.2s ease-in;
  svg {
    transition: all 0.2s ease-in;
  }
  &.opened {
    svg {
      transform: rotate(180deg);
    }
  }
}
.main_class_container {
  position: relative;
  .hero_list_container {
    width: 100%;
    height: max-content;
    position: absolute;
    top: 120%;
    max-height: 300px;
    overflow: auto;
    left: 0;
    background-color: var(--bg-main);
    border: 1px solid var(--stroke-medium);
    padding: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 18px;
    flex-direction: column;
    border-radius: 6px;
    z-index: 99;
  }
}
.class_item {
  padding: 1px 2px;
  transition: all 0.2s ease;
  &:hover {
    background-color: var(--bg-dark);
  }
}
.category_title {
  .divider {
    width: 45%;
    // background-color: var(--bg-light);
    border-top: 1px dashed var(--bg-light);
    height: 0px;
  }
}
</style>
